import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../ui';
import { DownloadButton } from '../../utils';
import { StyledTableUtils } from '../../ui/pageWithTable/styled';

export interface BillDownloadUtilProps {
  checkedBills: string[];
  tableRows: any;
  onCheckAllButtonClick: any;
  onDownloadButtonClick: any;
}

export const BillDownloadUtil: FC<BillDownloadUtilProps> = ({
  checkedBills,
  tableRows,
  onCheckAllButtonClick,
  onDownloadButtonClick,
}) => {
  const [mainCheckboxIsActive, setMainCheckboxIsActive] =
    useState<boolean>(false);

  const { t } = useTranslation();

  useEffect(() => {
    setMainCheckboxIsActive(
      tableRows.length !== 0 && checkedBills.length === tableRows.length,
    );
  }, [checkedBills, tableRows]);

  const getFileName = () => {
    const fileName = '';
    if (checkedBills.length > 0) {
      return checkedBills.length > 1
        ? 'racuni.zip'
        : `${checkedBills[0].trim()}.pdf`;
    }

    return fileName;
  };

  return (
    <StyledTableUtils>
      {tableRows.length > 0 ? (
        <Checkbox
          text={t('billsPage.billUtil.checkAllText')}
          onCheckboxClicked={onCheckAllButtonClick}
          shouldBeChecked={mainCheckboxIsActive}
        />
      ) : (
        <div />
      )}

      <DownloadButton
        disabled={checkedBills.length < 1}
        apiCall={onDownloadButtonClick()}
        fileName={getFileName()}
      />
    </StyledTableUtils>
  );
};
